<template>
  <div>
    <div v-for="(data, key) in fetchSettingsOne" :key="key">
      <component :is="componentLoader('ImageText')">
        <img slot="image" class="img-fluid rounded mb-6 mb-md-0" :src="data.image+`w=400&h=600&fit=crop`" alt="">
        <span slot="title">{{ data.name }}</span>
        <span slot="html-text" v-html="data.text"></span>
      </component>
    </div>
  </div>
</template>
<script>
  import settings from '@fremcast/section/mixins/section';
  export default {
    mixins: [
      settings
    ]
  }
</script>